module.exports = __webpack_public_path__ + "static/media/map-point.535bf920.png";